import { CSSProperties } from 'react';

export const containerStyle: CSSProperties = {
  position: 'absolute',
  width: '100%',
  height: '100%',
  top: 10,
  background: 'rgb(245 245 245 / 100%)'
};
